import { render, staticRenderFns } from "./AddSameModal.vue?vue&type=template&id=74b0c91b&scoped=true&"
import script from "./AddSameModal.vue?vue&type=script&lang=js&"
export * from "./AddSameModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSameModal.vue?vue&type=style&index=0&id=74b0c91b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0c91b",
  null
  
)

export default component.exports